import { FUND_INVESTMENTS } from 'common/endpoints';
import { FundInvestmentPayload } from 'pages/FundInvestments';
import BaseServiceRetryWrapper from './baseRetry';

class FundInvestmentsService extends BaseServiceRetryWrapper {
  updateFundInvestmentDetails = (allocationId: number, data: FundInvestmentPayload) =>
    this.post(FUND_INVESTMENTS.updateFundInvestmentDetails(allocationId), data);
}

export default FundInvestmentsService;
